const langIt_migross_migross = {
  "df-store-card.store-selection": "Scegli il punto vendita",
  "df-section-promotions.title.flyer": "Scopri le nostre promozioni",
  "df-section-promotions.title.catalog": "Scopri i nostri cataloghi",
  "df-section-promotions.title.magazine": "Scopri i nostri magazine e cataloghi",
};

export default langIt_migross_migross;
